<template>
  <div class="main-page home_page_yun grayscale"
       style="padding:0">
    <img src="https://qiniu.laway.cn/yn/2022/10/16/7de386fa4d2c11ed9d41b4055d0b07be.png"
         width="100%"
         style="display:block;height:1rem;margin-bottom:0.2rem"
         alt="">
    <header class="header_home"
            style="padding:0 0.6rem">
      <div class="c-left">
        <img class="logo "
             src="https://qiniu.terminal.laway.cn/ysxa_logo.png"
             alt="云上学安">
        <div class="qr"
             style="margin-left:0.5rem;">
          <img src="https://qiniu.terminal.laway.cn/ysxa_wechat.jpg"
               height="100"
               alt="">
          <div>
            <strong>云上学安</strong>
            <p>关注微信公众号</p>
          </div>
        </div>
      </div>
      <div class="c-right ">
        <div class="r-suggest"
             @click="$router.push('/suggest')">
          <img src="/img/ui/home/suggest.png"
               alt="建议反馈"
               class="suggest">
          <span>
            建议反馈
          </span>
        </div>
      </div>
    </header>
    <article class="main-content">
      <div class="main-box"
           v-for="(item, index) of mainList"
           :key="'keys-' + index"
           @click="toNewurl(item)">
        <img :src="item.icon"
             alt=""
             srcset="">
        <div>
          <strong>{{ item.title }}</strong>
          <p>{{ item.intro }}</p>
        </div>
      </div>
    </article>
    <HomeFoot :showPro="false" />

  </div>
</template>
<script>
import HomeFoot from '@/components/home/HomeFoot'

export default {
  name: 'YunshangxueanHome',
  components: {
    HomeFoot,
  },
  data () {
    return {

      help: {
        show: false
      },
      mainList: [
        {
          title: '精准法律咨询',
          intro: '只需几分钟即可免费获得精准法律意见书',
          advisory: true,
          icon: '/img/ui/home/logo_advice.png'
        },
        {
          title: '法律文书模板',
          intro: '免费提供协议书、起诉状等模版下载',
          path: '/service/11',
          icon: '/img/ui/home/logo_instrument.png'
        },
        {
          title: '法律法规查询',
          intro: '查询相关的法律法规',
          icon: '/img/ui/home/logo_case.png',
          isLaw: true
        }
      ],
    }
  },

  methods: {
    toNewurl (item) {
      if (item.path) {
        this.$router.push(item.path)
      }
      if (item.advisory) {
        this.toAdvisorys()
      }
      if (item.isLaw) {
        this.toLaw()
      }
    },
  }
}
</script>
<style lang="stylus">
.home_page_yun
  position relative
  box-sizing border-box
  padding 0.44rem 0.6rem 0
  overflow hidden
  &.page-home-flat
    padding-top 1rem
  #floatwindow
    position absolute
    top 1.6rem
    left 0
    width 4.5rem
    height 2.24rem
    border-radius 0.12rem
    background #fff
    overflow hidden
    z-index 100
    a
      display block
      width 100%
      height 100%
      img
        width 100%
        height 100%
        object-fit cover
  .main-content
    display flex
    justify-content center
    align-items center
    margin 1rem 0
    .main-box
      border 1px solid #ccc
      width 5rem
      height 5rem
      margin 0 0.1rem
      border-radius 0.2rem
      display flex
      justify-content center
      align-items center
      flex-direction column
      padding 0 0.3rem
      color #fff
      text-align center
      img
        margin-bottom 0.2rem
        width 2rem
        height 2rem
      strong
        font-size 0.45rem
      p
        margin 0.2rem 0
  .header_home
    display flex
    justify-content space-between
    align-items center
    margin-bottom 0.56rem
    .c-left
      display flex
      align-items center
      color #fff
      .logo
        margin-right 0.3rem
        flex-shrink 0
        height 0.73rem
      .qr
        display flex
        align-items center
        font-size 0.2rem
        img
          margin-right 0.15rem
        strong
          display block
          font-size 0.26 rem
          margin-bottom 0.02rem
      .phone
        margin-left 0.56rem
        display flex
        align-items center
        font-size 0.14rem
        img
          width 0.6rem
          margin-right 0.14rem
        strong
          font-size 0.3rem
          font-style italic
      .performance
        margin-left 0.5rem
        a
          display block
    .c-right
      display flex
      align-items center
      color #e3edff
      font-size 0.18rem
      .r-help, .r-suggest
        display flex
        align-items center
      .r-help
        margin-right 0.48rem
      img
        margin-right 0.1rem
        &.help
          width 0.24rem
        &.suggest
          width 0.2rem
  footer p
    text-align center
    font-size 0.2rem
    color #7b79a7
    margin-top 0.35rem
    margin-bottom 0.45rem
    .c1
      margin-right 0.2rem
    .c2
      margin-left 0.2rem
.login-input
  font-size 0.26rem
  line-height 1
  height 0.8rem
.input-label
  font-size 0.3rem
  line-height 0.8rem
.login-btns
  color #fff !important
.login-row
  margin-bottom 0.2rem
.setting-btn
  text-decoration none
  color #fff
  margin-left 0.4rem
</style>
